<template>
  <v-layout>
    <v-flex v-if="!isComplete">
      <div>{{ name }}</div>
    </v-flex>
    <v-flex v-if="isComplete">
      <a :href="mapReportUrl" target="_blank" rel="noopener noreferrer">{{
        name
      }}</a>
      <v-btn
        v-if="this.url.length > 0"
        :href="getEditMapboxUrl(this.url)"
        icon
        target="_blank"
        rel="noopener noreferrer"
        ><v-icon>mdi-mapbox</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { MapReportStatuses } from '@/models/MapReport'

export default {
  name: 'AdminMapReportListName',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputName: this.name,
    }
  },
  computed: {
    isComplete() {
      return this.status === MapReportStatuses.Completed
    },
    mapReportUrl() {
      return `../map_reports/${this.id}`
    },
  },
  methods: {
    getEditMapboxUrl(url) {
      return url.replace('mapbox://', 'https://studio.mapbox.com/')
    },
  },
}
</script>

<style scoped></style>
